// src/utils/dian.ts
// Utilidades de representación gráfica de la factura electrónica.

import { DocumentoElectronico } from '../services/api/facturacionElectronicaApi';

/**
 * URL del catálogo de la DIAN donde se verifica el documento.
 * Es el contenido que debe llevar el QR impreso: al escanearlo, el cliente
 * (o un inspector) ve la factura validada en la DIAN.
 *
 * Habilitación (pruebas) y producción tienen catálogos distintos; imprimir el
 * de producción en una factura de pruebas llevaría a un documento inexistente.
 */
export const urlCatalogoDian = (cufe: string, esProduccion = false): string =>
  `https://catalogo-vpfe${esProduccion ? '' : '-hab'}.dian.gov.co/document/searchqr?documentkey=${cufe}`;

/**
 * Contenido del QR a imprimir.
 * - Si el proveedor entregó un QR propio, se respeta (algunos incluyen el
 *   formato completo que exige el anexo técnico).
 * - Si no, se construye la URL del catálogo a partir del CUFE.
 * - Sin CUFE (venta no electrónica) se devuelve null: no se pinta QR DIAN.
 */
export const contenidoQrDian = (
  doc?: DocumentoElectronico | null,
  esProduccion = false,
): string | null => {
  if (!doc || doc.Estado !== 'VALIDADO') return null;
  if (doc.QR) return doc.QR;
  if (doc.CUFE) return urlCatalogoDian(doc.CUFE, esProduccion);
  return null;
};

/** Parte el CUFE en bloques para que sea legible al imprimirlo. */
export const cufeLegible = (cufe?: string | null, bloque = 24): string => {
  if (!cufe) return '';
  return (cufe.match(new RegExp(`.{1,${bloque}}`, 'g')) ?? []).join(' ');
};
